import * as angular from 'angular';
import { range } from 'lodash';

export class PaginatorController {
  public currPage: number;
  public innerWindowSize: number;
  public leftOuterWindowSize: number;
  public rightOuterWindowSize: number;
  public pageRange: number;
  public onPageSelection: (args: { $pageIndex: number }) => void;
  private pageNavControls: any[];
  public showMeta = true;
  public numItemsPage: number;
  public numItemsTotal: number;

  static $inject = [];

  $onInit() {
    this.currPage = this.currPage || 0;
    this.innerWindowSize = this.innerWindowSize || 4;
    this.leftOuterWindowSize = this.leftOuterWindowSize || 0;
    this.rightOuterWindowSize = this.rightOuterWindowSize || 0;
    this.updatePageNavControls();
  }

  $onChanges(changed) {
    if (changed.currPage || changed.pageRange) {
      this.updatePageNavControls();
    }
  }

  updatePageNavControls() {
    this.pageNavControls = this.buildPageList();
  }

  buildPageList(): any[] {
    const currPageIndex = this.currPage;
    const leftOuterWindow = PaginatorController.resolveLeftOuterWindow(
      this.pageRange,
      this.leftOuterWindowSize,
      this.innerWindowSize,
      currPageIndex
    );
    const innerWindow = PaginatorController.resolveInnerWindow(this.pageRange, this.innerWindowSize, currPageIndex);
    const rightOuterWindow = PaginatorController.resolveRightOuterWindow(
      this.pageRange,
      this.rightOuterWindowSize,
      this.innerWindowSize,
      currPageIndex
    );
    let leftSeparator = [];
    let rightSeparator = [];

    if (currPageIndex > this.innerWindowSize) {
      leftSeparator = ['...'];
    }

    if (currPageIndex < this.pageRange - this.innerWindowSize - 1) {
      rightSeparator = ['...'];
    }

    return [...leftOuterWindow, ...leftSeparator, ...innerWindow, ...rightSeparator, ...rightOuterWindow];
  }

  static resolveLeftOuterWindow(
    pageRange: number,
    leftOuterWindowSize: number,
    innerWindowSize: number,
    currPageIndex: number
  ): any[] {
    if (leftOuterWindowSize && leftOuterWindowSize < currPageIndex - innerWindowSize - 1) {
      return range(1, leftOuterWindowSize + 1);
    } else {
      return [];
    }
  }

  static resolveRightOuterWindow(
    pageRange: number,
    rightOuterWindowSize: number,
    innerWindowSize: number,
    currPageIndex: number
  ): any[] {
    if (rightOuterWindowSize && currPageIndex + innerWindowSize + 1 < pageRange - innerWindowSize) {
      return range(pageRange - rightOuterWindowSize + 1, pageRange + 1);
    } else {
      return [];
    }
  }

  static resolveInnerWindow(pageRange: number, innerWindowSize: number, currPageIndex: number): any[] {
    const innerWindowSliceStart = Math.max(currPageIndex - innerWindowSize, 0);
    const innerWindowSliceStop = 1 + currPageIndex + innerWindowSize;

    return range(1, pageRange + 1).slice(innerWindowSliceStart, innerWindowSliceStop);
  }

  isSeparator(control: any) {
    return control === '...';
  }

  isPage(control: any) {
    return 'number' === typeof control;
  }

  getPageIndex(pageNumber: number) {
    return pageNumber - 1;
  }

  getPageNumber(pageIndex: number) {
    return pageIndex + 1;
  }

  handlePageSelection($event: Event, control: number) {
    $event.preventDefault();

    this.onPageSelection({ $pageIndex: control });
  }

  handleNextPageSelection($event: Event) {
    $event.preventDefault();

    this.onPageSelection({ $pageIndex: this.currPage + 1 });
  }

  handlePreviousPageSelection($event: Event) {
    $event.preventDefault();

    this.onPageSelection({ $pageIndex: this.currPage - 1 });
  }
}

export const PaginatorComponent: angular.IComponentOptions = {
  controller: PaginatorController,
  controllerAs: 'ctrl',
  bindings: {
    currPage: '<',
    innerWindowSize: '<',
    leftOuterWindowSize: '<',
    onPageSelection: '&',
    rightOuterWindowSize: '<',
    pageRange: '<',
    showMeta: '<',
    numItemsPage: '<',
    numItemsTotal: '<',
  },
  template: `
    <div class="paginator-container" ng-if="ctrl.pageRange > 0">
      <ul class="pagination">
        <li class="paginator-control pagination-prev"
            ng-class="{ 'disabled': ctrl.currPage === 0 }">
          <a rel="prev"
             href="#"
             ng-click="ctrl.handlePreviousPageSelection($event)">
            &lt;&nbsp;Prev
          </a>
        </li>

        <li class="paginator-control"
            ng-repeat="control in ctrl.pageNavControls track by $index"
            ng-class="{ 'pagination-gap': ctrl.isSeparator(control), 'pagination-page': ctrl.isPage(control), 'active': ctrl.isPage(control) && ctrl.getPageIndex(control) === ctrl.currPage}" >
          <a href="#"
             ng-if="ctrl.isPage(control)"
             ng-click="ctrl.handlePageSelection($event, ctrl.getPageIndex(control))"
             ng-class="{ 'disabled': ctrl.getPageIndex(control) === ctrl.currPage }">
            {{ control }}
          </a>

          <span ng-if="ctrl.isSeparator(control)">&hellip;</span>
        </li>

        <li class="paginator-control pagination-next"
            ng-class="{ 'disabled': ctrl.getPageNumber(ctrl.currPage) === ctrl.pageRange }">
          <a rel="next"
             href="#"
             ng-click="ctrl.handleNextPageSelection($event)">
            Next&nbsp;&gt;
          </a>
        </li>
      </ul>
      <div class="pagination-meta" ng-if="ctrl.showMeta !== false">
        <p>showing {{ctrl.numItemsPage}} of {{ctrl.numItemsTotal}}</p>
      </div>
    </div>
  `,
};
